<template>
  <section class="form-fw__content">
    <form
      class="form--custom"
      novalidate
      @submit.prevent="handleSubmit"
    >
      <fieldset class="form__container">
        <div>
          <header v-if="!currentStatus || isLoading" class="form__container__header">
            <span>
              <strong>{{ $t(`${namespace}.documentLayoutText`) }}</strong>
              {{ $t(`${namespace}.makeSureTheSpreadsheet`) }} <a :href="nfeLayout" :title="$t(`${namespace}.csvSample`)" class="accent--text">{{ $t(`${namespace}.csvSample`) }}</a>.
            </span>
          </header>

          <div class="form__container__content pt-0">
            <div v-if="!currentStatus" class="form__drag-in-drop">
              <input type="file" accept=".csv" ref="file" @change="handleSubmit($event.target)">
              <label >
                <span v-html="$t(`${namespace}.uploadText`)" class="form__drag-in-drop__text" />

                <v-btn large depressed round color="accent" :loading="isLoading" :disabled="isLoading">
                  <v-icon class="mr-1">cloud_upload</v-icon>
                  <span class="hidden-xs--inline">{{ $t(`${namespace}.uploadBtnLabel`) }}</span>
                  <span class="visible-xs--inline">{{ $t('Common.import') }}</span>
                </v-btn>
              </label>
            </div>

            <div v-if="isLoading" class="form__drag-in-drop">
              <strong class="form__drag-in-drop__text">{{ $t(`${namespace}.uploadLoadingText`) }}</strong>
              <v-progress-circular indeterminate color="accent" size="36" />
            </div>
          </div>
        </div>

        <div v-if="isSuccess" class="status__box">
          <h2 class="status__box__title">{{ $t(`${namespace}.spreadsheetImportedSuccessfully`) }}</h2>
          <span class="status__box__filename">{{ filename }}</span>
          <!-- <span class="status__box__count status__box__count--success">{{ count | formatNumber }}</span> -->
          <!-- <span v-html="$t(`${namespace}.totalLines`)" class="status__box__lines" /> -->
        </div>

        <div v-if="isFailed" class="status__box">
          <h2 class="status__box__title">{{ $t(`${namespace}.uploadTitleError`) }} <span class="error--text">:(</span></h2>
          <span class="status__box__filename">{{ filename }}</span>
          <!-- <span class="status__box__count status__box__count--error">{{ count | formatNumber }}</span> -->

          <div class="status__box__text">
            <p
              v-html="$t(`${namespace}.uploadTextError`).replace(
                '[HERE]',
                '<a href='+ nfeLayout +' class=\'accent--text\'>'+ $t('Common.here') +'</a>'
              )"
              class="status__box__text"
            />
          </div>
        </div>
      </fieldset>
    </form>

    <Footer :status="currentStatus" @setCurrentStatus="setCurrentStatus" />
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import Footer from 'components/revenuesNfeImport/Footer'

export default {
  name: 'RevenuesNfeImportForm',
  components: {
    Footer
  },
  computed: {
    ...mapState({
      globalCompany: (state) => state.company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      currentStatus: null,
      file: null,
      filename: null,
      count: 0,
      nfeLayout: 'http://notadomilhao.prefeitura.sp.gov.br/cidadao/informacoes-gerais/manuais-arquivos/nfe_layout_rps.pdf/@@download/file/NFe_Layout_RPS%20.pdf'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    setCurrentStatus (val) {
      this.currentStatus = val
    },

    resetFields () {
      this.file = null

      if (this.$refs.file) {
        this.$refs.file.value = null
      }
    },

    validateFile (elem) {
      if (!elem.files.length) {
        this.hasFile = false
        return
      }

      const regex = /^NFSe_RPS_[0-9]{8}_[0-9]{8}_[0-9]{8}(?:_[0-9]{13})?\.csv$/

      this.file = elem.files[0]
      this.filename = this.file.name

      if (!regex.test(this.filename)) {
        this.resetFields()
        this.currentStatus = STATUS_FAILED
        return false
      }

      return true
    },

    async handleSubmit (elem) {
      if (!this.validateFile(elem)) return

      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          this.currentStatus = STATUS_IS_LOADING

          const formData = new FormData()
          formData.append('file', this.file)

          await this.$apiService.uploadNfe(formData)

          this.resetFields()
          this.currentStatus = STATUS_SUCCESS
        }
      } catch (err) {
        console.log('ERROR', err)
        this.resetFields()
        this.currentStatus = STATUS_FAILED
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status__box {
  text-align: center;
  padding: 24px;
}

.status__box__title {
  font-size: 14px;
  font-weight: bold;
  font-family: 'Montserrat', sans-serif;
}

.status__box__filename,
.status__box__count,
.status__box__lines,
.status__box__text {
  color: $gray-6;
  display: block;
}

.status__box__title,
.status__box__filename,
.status__box__count {
  margin-bottom: 24px;
}

.status__box__filename {}

.status__box__count {
  background-color: #eee;
  border-radius: 16px;
  display: inline-block;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 800;
  line-height: normal;
  min-width: 76px;
  padding: 5px 0;

  &.status__box__count--success {
    background-color: $success;
    color: #fff;
  }

  &.status__box__count--error {
    background-color: $error;
  color: #fff;
  }
}

.status__box__lines {}

.status__box__text {}
</style>
